
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter" />
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm" :rules="rules">
          <div class="lg:mb-2">
            <!-- #region Fecha de Alta -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('verifactu.filters.create_date_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="FechaAltaDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaAltaDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="FechaAltaHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaAltaHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->
            
            <!-- #region Fecha Expedición -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('verifactu.filters.expedition_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="FechaExpedicionDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaExpedicionDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="FechaExpedicionHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaExpedicionHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Fecha Notificación -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('verifactu.filters.notification_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.from') }}</label>
                      <el-form-item prop="FechaNotificacionDesde">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaNotificacionDesde.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.to') }}</label>
                      <el-form-item prop="FechaNotificacionHasta">
                        <el-date-picker class="bg-white dark:bg-darkblue-900 dark:bg-darkblue"
                          v-model="form.FechaNotificacionHasta.value" type="date" :picker-options="dateRangeOptions"
                          :format="datePattern" value-format="yyyy-MM-dd[T00:00:00]" placeholder="">
                        </el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Cuota -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('verifactu.filters.quota_from_to') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="CuotaTotalDesde">
                        <el-input clearable class="w-full" v-model="form.CuotaTotalDesde.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="CuotaTotalHasta">
                        <el-input clearable class="w-full" v-model="form.CuotaTotalHasta.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Importe -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.filters.invoice_importe_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="ImporteTotalDesde">
                        <el-input clearable class="w-full" v-model="form.ImporteTotalDesde.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="ImporteTotalHasta">
                        <el-input clearable class="w-full" v-model="form.ImporteTotalHasta.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Distribuidor + Cliente -->
            <div
              v-if="(role === 7 || role === 8 || role === 3)">
              <div v-if="role === 3">
                <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('distributors.entity_name') }}</label>
                <el-form-item prop="idDistribuidor">
                  <base-el-select class="w-full" :options="distribuidores" v-model="form.idDistribuidor.value" clearable filterable
                    value-key="idDistribuidor" :loading="loadingDistribuidores" />
                </el-form-item>
              </div>

              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('clients.entity_name') }}</label>
              <el-form-item prop="idCliente">
                <base-el-select class="w-full" :options="clientes" v-model="form.idCliente.value" clearable filterable
                  value-key="idCliente" :loading="loadingClientes" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Empresa -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.entity_name') }}</label>
              <el-form-item prop="Empresa">
                <base-el-select class="w-full" :options="empresas" v-model="form.Empresa.value" clearable filterable
                  value-key="idCifEmpresa" :loading="loadingCompanies" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region CIF Empresa -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.company_cif') }}</label>
              <el-form-item prop="idCifEmpresa">
                <el-input clearable class="w-full" v-model="form.idCifEmpresa.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region CIF -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.cif') }}</label>
              <el-form-item prop="CIF">
                <el-input clearable class="w-full" v-model="form.CIF.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Serie Numero de Factura -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.invoice_num_serie') }}</label>
              <el-form-item prop="NumSerieFactura">
                <el-input clearable class="w-full" v-model="form.NumSerieFactura.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region SIF -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.sif') }}</label>
              <el-form-item prop="SIF">
                <el-input clearable class="w-full" v-model="form.SIF.value" maxlength="50" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Estado -->
            <div v-if="isGeneralStatus">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.status') }}</label>
              <el-form-item prop="IdEstadoVerifactu">
                <base-el-select :options="tiposEstados" :loading="isLoading" v-model="form.IdEstadoVerifactu.value" class="w-full" clearable filterable/>
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Acciones Verifactu -->
            <div v-if="isGeneralStatus">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.action_type') }}</label>
              <el-form-item prop="IdAccionVerifactu">
                <base-el-select :options="tiposAccion" :loading="isLoading" v-model="form.IdAccionVerifactu.value" class="w-full" clearable filterable/>
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Tipo Factura -->
            <div v-if="isGeneralStatus">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.invoice_type.entity_name') }}</label>
              <el-form-item prop="IdTipoFactura">
                <base-el-select :options="tiposFactura" :loading="isLoading" v-model="form.IdTipoFactura.value" class="w-full" clearable filterable/>
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region Huella Registro -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.register_print') }}</label>
              <el-form-item prop="HuellaRegistro">
                <el-input clearable class="w-full" v-model="form.HuellaRegistro.value" maxlength="100" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region CSV ZC -->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.csvzc') }}</label>
              <el-form-item prop="CSVZC">
                <el-input clearable class="w-full" v-model="form.CSVZC.value" maxlength="100" />
              </el-form-item>
            </div>
            <!-- #endregion -->

            <!-- #region CSV AEAT-->
            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('verifactu.csvaeat') }}</label>
              <el-form-item prop="CSVAEAT">
                <el-input clearable class="w-full" v-model="form.CSVAEAT.value" maxlength="100" />
              </el-form-item>
            </div>
            <!-- #endregion -->

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"
        :loading="isLoading" />
    </template>
  </base-slide-panel>
</template>

<script>

import { i18n } from '@/i18n'
import getLocaleDateTimeFormat from '@/services/functions/getLocaleDateTimeFormat'
import { getClients } from '@/services/clients/getClients'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getAllCompanies } from '@/services/companies/getAllCompanies'

export default {
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 99999
    }
  },
  data: function () {
    return {
      rules: {},
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      loadingCompanies: false,
      loadingDistribuidores: false,
      loadingMetadatos: false,
      loadingClientes: false,
      loadingGrupos: false,
      types: [],
      finalListMetadatasClient: [],
      maxMetadatosFilter: 5,
      form: {
        FechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        FechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        FechaExpedicionDesde: { label: i18n.t('verifactu.filters.expedition_from'), value: '' },
        FechaExpedicionHasta: { label: i18n.t('verifactu.filters.expedition_to'), value: '' },
        FechaNotificacionDesde: { label: i18n.t('verifactu.filters.noification_from'), value: '' },
        FechaNotificacionHasta: { label: i18n.t('verifactu.filters.noification_to'), value: '' },
        CuotaTotalDesde: { label: i18n.t('verifactu.filters.quota_from'), value: '', type: 'number' },
        CuotaTotalHasta: { label: i18n.t('verifactu.filters.quota_to'), value: '', type: 'number' },
        ImporteTotalDesde: { label: i18n.t('verifactu.filters.amount_from'), value: '', type: 'number' },
        ImporteTotalHasta: { label: i18n.t('verifactu.filters.amount_to'), value: '', type: 'number' },
        idDistribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        idCliente: { label: i18n.t('clients.entity_name'), value: '' },
        idCifEmpresa: { label: i18n.t('verifactu.company_cif'), value: '' },
        CIF: { label: i18n.t('companies.cif'), value: '' },
        Empresa: { label: i18n.t('companies.entity_name'), value: '' },
        NumSerieFactura: { label: i18n.t('invoices.serie_factura'), value: '' },
        SIF: { label: i18n.t('verifactu.sif'), value: '' },
        IdEstadoVerifactu: { label: i18n.t('app.status'), value: '' },
        IdAccionVerifactu: { label: i18n.t('verifactu.action_type'), value: '' },
        IdTipoFactura: { label: i18n.t('verifactu.invoice_type.entity_name'), value: '' },
        HuellaRegistro: { label: i18n.t('verifactu.register_print'), value: '' },
        CSVZC: { label: i18n.t('verifactu.csvzc'), value: '' },
        CSVAEAT: { label: i18n.t('verifactu.csvaeat'), value: '' },
      },
      listGroupingEmpresas: [],
      distribuidores: [],
      clientes: [],
      empresas: [],
      valuesNombresGroups: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  computed: {
    datePattern () {
      const formatKey = 'numeric_date'
      const locale = i18n.locale || 'es'
      return getLocaleDateTimeFormat(formatKey, locale)
    },
    isRoleProvider: function () {
      return this.role === 9
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasModuleAgrupaciones']
    },
    hasTBAIModule () {
      return !!this.$store.getters['auth/hasTBAIModule']
    },
    actualPath: function () {
      return this.$store.getters['app/actualRoute']
    },
    ultimoErrorActive: function () {
      return true
      // return this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoicesissued/9' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoices/-1' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/invoices/notices/error'
    },
    motivoRechazoActive: function () {
      // return true
      return this.isGeneralStatus || ['6', 6].includes(this.status)
    },
    isGeneralStatus: function () {
      return this.status === '99999' || this.status === 99999
    },
    isLoading: function () {
      return this.loadingClientes || this.loadingGrupos || this.loadingMetadatos || this.loadingDistribuidores
    },
    idCliente: function () {
      return this.form.empresa?.value?.idCliente
    },
    tiposEstados: function () {
      return this.$store.getters['config/TIPOS_ESTADO_VERIFACTU']
    },
    tiposAccion: function () {
      return this.$store.getters['config/TIPOS_OPERACION']
    },
    tiposFactura: function () {
      return this.$store.getters['config/TIPOS_FACTURA']
    },
  },
  watch: {},
  mounted: async function () {
    try {
      this.loadingCompanies = true
      const dataCompanies = await getAllCompanies()
      if (dataCompanies.blnError === true) {
        this.doFeedback(`${dataCompanies.msgError} [${dataCompanies.codError}]`)
      }
      this.empresas = dataCompanies.CIFSEmpresa.map(x => ({ label: x.RazonSocial, key: x.IdCIFEmpresa, value: { idCifEmpresa: x.IdCIFEmpresa, Nombre: x.RazonSocial } }))
      this.loadingCompanies = false
    } catch (error) {
      this.doFeedback()      
    }
    
    if (this.role === 7 || this.role === 8 || this.role === 3) {
      this.loadingClientes = true
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(`${dataClients.msgError} [${dataClients.codError}]`)
      }
      this.clientes = dataClients.Clientes.map(x => ({ label: x.Nombre, key: x.idCliente, value: { idCliente: x.idCliente, Nombre: x.Nombre } }))
      this.loadingClientes = false

      if (this.role === 3) {
        this.loadingDistribuidores = true
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(`${dataDistributors.msgError} [${dataDistributors.codError}]`)
        }
        this.distribuidores = dataDistributors.Distribuidores.map(x => ({ label: x.Nombre, key: x.IdDistribuidor, value: { idDistribuidor: x.IdDistribuidor, Nombre: x.Nombre } }))
        this.loadingDistribuidores = false
      }
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters['verifactu/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.FechaAltaDesde.value = _temp.FechaAltaDesde !== undefined && _temp.FechaAltaDesde.value !== '' ? _temp.FechaAltaDesde.value : ''
        this.form.FechaAltaHasta.value = _temp.FechaAltaHasta !== undefined && _temp.FechaAltaHasta.value !== '' ? _temp.FechaAltaHasta.value : ''
        this.form.FechaExpedicionDesde.value = _temp.FechaExpedicionDesde !== undefined && _temp.FechaExpedicionDesde.value !== '' ? _temp.FechaExpedicionDesde.value : ''
        this.form.FechaExpedicionHasta.value = _temp.FechaExpedicionHasta !== undefined && _temp.FechaExpedicionHasta.value !== '' ? _temp.FechaExpedicionHasta.value : ''
        this.form.FechaExpedicionHasta.value = _temp.FechaExpedicionHasta !== undefined && _temp.FechaExpedicionHasta.value !== '' ? _temp.FechaExpedicionHasta.value : ''
        this.form.FechaNotificacionDesde.value = _temp.FechaNotificacionDesde !== undefined && _temp.FechaNotificacionDesde.value !== '' ? _temp.FechaNotificacionDesde.value : ''
        this.form.CuotaTotalDesde.value = _temp.CuotaTotalDesde !== undefined && _temp.CuotaTotalDesde.value !== '' ? _temp.CuotaTotalDesde.value : ''
        this.form.CuotaTotalHasta.value = _temp.CuotaTotalHasta !== undefined && _temp.CuotaTotalHasta.value !== '' ? _temp.CuotaTotalHasta.value : ''
        this.form.ImporteTotalDesde.value = _temp.ImporteTotalDesde !== undefined && _temp.ImporteTotalDesde.value !== '' ? _temp.ImporteTotalDesde.value : ''
        this.form.ImporteTotalHasta.value = _temp.ImporteTotalHasta !== undefined && _temp.ImporteTotalHasta.value !== '' ? _temp.ImporteTotalHasta.value : ''
        this.form.idDistribuidor.value = _temp.idDistribuidor !== undefined && _temp.idDistribuidor.value !== '' ? _temp.idDistribuidor.value : ''
        this.form.idCliente.value = _temp.idCliente !== undefined && _temp.idCliente.value !== '' ? _temp.idCliente.value : ''
        this.form.idCifEmpresa.value = _temp.idCifEmpresa !== undefined && _temp.idCifEmpresa.value !== '' ? _temp.idCifEmpresa.value : ''
        this.form.CIF.value = _temp.CIF !== undefined && _temp.CIF.value !== '' ? _temp.CIF.value : ''
        this.form.Empresa.value = _temp.Empresa !== undefined && _temp.Empresa.value !== '' ? _temp.Empresa.value : ''
        this.form.NumSerieFactura.value = _temp.NumSerieFactura !== undefined && _temp.NumSerieFactura.value !== '' ? _temp.NumSerieFactura.value : ''
        this.form.SIF.value = _temp.SIF !== undefined && _temp.SIF.value !== '' ? _temp.SIF.value : ''
        this.form.IdEstadoVerifactu.value = _temp.IdEstadoVerifactu !== undefined && _temp.IdEstadoVerifactu.value !== '' ? _temp.IdEstadoVerifactu.value : ''
        this.form.IdAccionVerifactu.value = _temp.IdAccionVerifactu !== undefined && _temp.IdAccionVerifactu.value !== '' ? _temp.IdAccionVerifactu.value : ''
        this.form.IdTipoFactura.value = _temp.IdTipoFactura !== undefined && _temp.IdTipoFactura.value !== '' ? _temp.IdTipoFactura.value : ''
        this.form.HuellaRegistro.value = _temp.HuellaRegistro !== undefined && _temp.HuellaRegistro.value !== '' ? _temp.HuellaRegistro.value : ''
        this.form.CSVZC.value = _temp.CSVZC !== undefined && _temp.CSVZC.value !== '' ? _temp.CSVZC.value : ''
        this.form.CSVAEAT.value = _temp.CSVAEAT !== undefined && _temp.CSVAEAT.value !== '' ? _temp.CSVAEAT.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        FechaAltaDesde: { label: i18n.t('app.filters.fecha_alta_from'), value: '' },
        FechaAltaHasta: { label: i18n.t('app.filters.fecha_alta_to'), value: '' },
        FechaExpedicionDesde: { label: i18n.t('verifactu.filters.expedition_from'), value: '' },
        FechaExpedicionHasta: { label: i18n.t('verifactu.filters.expedition_to'), value: '' },
        FechaNotificacionDesde: { label: i18n.t('verifactu.filters.noification_from'), value: '' },
        FechaNotificacionHasta: { label: i18n.t('verifactu.filters.noification_to'), value: '' },
        CuotaTotalDesde: { label: i18n.t('verifactu.filters.quota_from'), value: '', type: 'number' },
        CuotaTotalHasta: { label: i18n.t('verifactu.filters.quota_to'), value: '', type: 'number' },
        ImporteTotalDesde: { label: i18n.t('verifactu.filters.amount_from'), value: '', type: 'number' },
        ImporteTotalHasta: { label: i18n.t('verifactu.filters.amount_to'), value: '', type: 'number' },
        idDistribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
        idCliente: { label: i18n.t('clients.entity_name'), value: '' },
        idCifEmpresa: { label: i18n.t('verifactu.company_cif'), value: '' },
        CIF: { label: i18n.t('companies.cif'), value: '' },
        Empresa: { label: i18n.t('companies.entity_name'), value: '' },
        NumSerieFactura: { label: i18n.t('invoices.serie_factura'), value: '' },
        SIF: { label: i18n.t('verifactu.sif'), value: '' },
        IdEstadoVerifactu: { label: i18n.t('app.status'), value: '' },
        IdAccionVerifactu: { label: i18n.t('verifactu.action_type'), value: '' },
        IdTipoFactura: { label: i18n.t('verifactu.invoice_type.entity_name'), value: '' },
        HuellaRegistro: { label: i18n.t('verifactu.register_print'), value: '' },
        CSVZC: { label: i18n.t('verifactu.csvzc'), value: '' },
        CSVAEAT: { label: i18n.t('verifactu.csvaeat'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit('verifactu/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.resetForm()
      this.$emit('togglePanel')
    },
  }
}
</script>
